import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BsPencilFill, BsTrashFill } from 'react-icons/bs';
import Header from '../../Component/Header';
import axios from '../../../Axiosinstance'; // Ensure this is the correct import path for your axios instance
import 'bootstrap/dist/css/bootstrap.min.css';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import NewBatches from './NewBatch';
import { toast, ToastContainer } from 'react-toastify';
import Loader from '../../../Loader';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,

} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const BatchesTable = () => {
    const [batches, setBatches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [currentBatch, setCurrentBatch] = useState(null);
    const [venues, setVenues] = useState([]);
    const [courses, setCourses] = useState([]);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');


    useEffect(() => {
        const fetchBatches = async () => {
            try {
                const response = await axios.get('/wsq/batches/all');
                setBatches(response.data);
            } catch (error) {
                console.error('Error fetching batches:', error);
                toast.error('Failed to fetch batches');
            } finally {
                setLoading(false);
            }
        };

        const fetchVenues = async () => {
            try {
                const response = await axios.get('/wsq/venues/finalls');
                setVenues(response.data);
            } catch (error) {
                console.error('Error fetching venues:', error);
            }
        };

        const fetchCourses = async () => {
            try {
                const response = await axios.get('/wsq/courses/finalls');
                setCourses(response.data);
            } catch (error) {
                console.error('Error fetching courses:', error);
            }
        };

        fetchBatches();
        fetchVenues();
        fetchCourses();
    }, []);

    const handleEditClick = (batch) => {
        // Ensure days are initialized as an empty array
        setCurrentBatch({ ...batch, days: batch.days || [] });
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentBatch(null);
    };

    const handleUpdate = async () => {
        const { name, intakeSize, language, course, venue, days } = currentBatch;

        const payload = {
            name,
            intakeSize,
            language, // Include the language in the payload
            courseId: course.id,  // Send only courseId
            venueId: venue.id,    // Send only venueId
            days: days.map(day => ({
                date: day.date,
                sessions: day.session.map(sess => ({
                    session: sess.session,
                    startTime: sess.startTime,
                    endTime: sess.endTime
                }))
            }))
        };

        try {
            const response = await axios.put(`/wsq/batches/${currentBatch.id}/update`, payload);
            const updatedBatches = batches.map(batch =>
                batch.id === currentBatch.id ? response.data : batch
            );
            setBatches(updatedBatches);
            toast.success('Batch updated successfully');
            handleClose();
        } catch (error) {
            console.error('Error updating batch:', error);
            toast.error('Failed to update batch');
        }
    };

    const handleDelete = async () => {
        try {
            await axios.delete(`/wsq/batches/${currentBatch.id}`);
            setBatches(batches.filter(batch => batch.id !== currentBatch.id));
            toast.success('Batch deleted successfully');
            handleDeleteClose();
        } catch (error) {
            console.error('Error deleting batch:', error);
            toast.error('Failed to delete batch');
        }
    };

    // Add a new day
    const addDay = () => {
        const newDay = { date: '', session: [{ session: '', startTime: '', endTime: '' }] };
        setCurrentBatch(prev => ({ ...prev, days: [...prev.days, newDay] }));
    };

    // Remove a day
    const removeDay = (index) => {
        setCurrentBatch(prev => ({ ...prev, days: prev.days.filter((_, i) => i !== index) }));
    };

    // Handle day change
    const handleDayChange = (index, event) => {
        const updatedDays = [...currentBatch.days];
        updatedDays[index].date = event.target.value;
        setCurrentBatch({ ...currentBatch, days: updatedDays });
    };

    // Add a session to a specific day
    const addSession = (dayIndex) => {
        const newSession = { session: '', startTime: '', endTime: '' };
        const updatedDays = [...currentBatch.days];
        updatedDays[dayIndex].session.push(newSession);
        setCurrentBatch({ ...currentBatch, days: updatedDays });
    };

    // Remove a session from a specific day
    const removeSession = (dayIndex, sessionIndex) => {
        const updatedDays = [...currentBatch.days];
        updatedDays[dayIndex].session = updatedDays[dayIndex].session.filter((_, i) => i !== sessionIndex);
        setCurrentBatch({ ...currentBatch, days: updatedDays });
    };

    // Handle session change
    const handleSessionChange = (dayIndex, sessionIndex, field, value) => {
        const updatedDays = [...currentBatch.days];
        updatedDays[dayIndex].session[sessionIndex][field] = value;
        setCurrentBatch({ ...currentBatch, days: updatedDays });
    };

    if (loading) {
        return <Loader />;
    }

    const handleDeleteClose = () => {
        setDeleteOpen(false);
        setCurrentBatch(null);
    };

    const handleDeleteClick = (batch) => {
        setCurrentBatch(batch);
        setDeleteOpen(true);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredBatches = batches.filter(batch =>
        batch.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <TextField
                label="Search Batches"
                variant="outlined"
                margin="normal"
                fullWidth
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Intake Size</TableCell>
                            <TableCell>Course Name</TableCell>
                            <TableCell>Course Fee</TableCell>
                            <TableCell>Venue</TableCell>
                            <TableCell>Days</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredBatches.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((batch) => (
                            <TableRow key={batch.id}>
                                <TableCell>{batch.id}</TableCell>
                                <TableCell>{batch.name.trim()}</TableCell>
                                <TableCell>{batch.intakeSize}</TableCell>
                                <TableCell>{batch.course.name}</TableCell>
                                <TableCell>{batch.course.fee}</TableCell>
                                <TableCell> {batch.venue.place}</TableCell>
                                <TableCell>
                                    {batch.days.length > 0 ? (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                            {batch.days.map((day) => {
                                                const date = new Date(day.date);
                                                const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
                                                return (
                                                    <div
                                                        key={day.date}
                                                        style={{
                                                            padding: '5px',
                                                            backgroundColor: '#f0f0f0',
                                                            borderRadius: '5px',
                                                            textAlign: 'center',
                                                            fontSize: '14px',
                                                            fontWeight: '500',
                                                        }}
                                                    >
                                                        {formattedDate}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div style={{ fontStyle: 'italic', color: '#757575' }}>No days scheduled</div>
                                    )}
                                </TableCell>

                                <TableCell>
                                    <IconButton color="primary" onClick={() => handleEditClick(batch)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton color="secondary" onClick={() => handleDeleteClick(batch)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredBatches.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />


            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Edit Batch</DialogTitle>
                <DialogContent>
                    {currentBatch && (
                        <>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Batch Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={currentBatch.name}
                                onChange={(e) => setCurrentBatch({ ...currentBatch, name: e.target.value })}
                            />
                            <TextField
                                margin="dense"
                                label="Intake Size"
                                type="number"
                                fullWidth
                                variant="outlined"
                                value={currentBatch.intakeSize}
                                onChange={(e) => setCurrentBatch({ ...currentBatch, intakeSize: e.target.value })}
                            />

                            {/* Dropdown for Course */}
                            <FormControl fullWidth margin="dense">
                                <InputLabel>Course</InputLabel>
                                <Select
                                    label='Course'
                                    value={currentBatch.course.id || ''} // Ensure course ID is mapped correctly
                                    onChange={(e) => {
                                        const selectedCourse = courses.find(course => course.id === e.target.value);
                                        setCurrentBatch({
                                            ...currentBatch,
                                            course: selectedCourse // Set selected course directly
                                        });
                                    }} // Updated to set ID
                                >
                                    {courses.map((course) => (
                                        <MenuItem key={course.id} value={course.id}>
                                            {course.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Dropdown for Language Selection */}
                            <FormControl fullWidth margin="dense">
                                <InputLabel>Language</InputLabel>
                                <Select
                                    value={currentBatch.language || ''} // Display current language
                                    label='Language'
                                    onChange={(e) => {
                                        setCurrentBatch({
                                            ...currentBatch,
                                            language: e.target.value // Update language
                                        });
                                    }}
                                >
                                    {/* Get available languages for the selected course */}
                                    {courses.find(c => c.id === currentBatch.course.id)?.languages.map((lang) => (
                                        <MenuItem key={lang} value={lang}>
                                            {lang}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Dropdown for Venue */}
                            <FormControl fullWidth margin="dense">
                                <InputLabel>Venue</InputLabel>
                                <Select
                                    label='Venue'
                                    value={currentBatch.venue.id || ''} // Ensure venue ID is mapped correctly
                                    onChange={(e) => setCurrentBatch({
                                        ...currentBatch,
                                        venue: venues.find(venue => venue.id === e.target.value) // Set selected venue
                                    })} // Updated to set ID
                                >
                                    {venues.map((venue) => (
                                        <MenuItem key={venue.id} value={venue.id}>
                                            {venue.roomno}, {venue.place}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* Days and Sessions */}
                            <h3>Days</h3>
                            {currentBatch.days.map((day, dayIndex) => (
                                <div key={dayIndex}>
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        margin="dense"
                                        label="Day Date"
                                        type="date"
                                        fullWidth
                                        value={day.date}
                                        onChange={(e) => handleDayChange(dayIndex, e)}
                                    />
                                    {day.session.map((sess, sessIndex) => (
                                        <div key={sessIndex}>
                                            <TextField
                                                margin="dense"
                                                label={`Session${sessIndex+1}`}
                                                type="text"
                                                value={sess.session}
                                                disabled // Prevent manual editing
                                                onChange={(e) => handleSessionChange(dayIndex, sessIndex, 'session', e.target.value)}
                                            />
                                            <TextField
                                                margin="dense"
                                                label="Start Time"
                                                type="time"
                                                InputLabelProps={{ shrink: true }}
                                                value={sess.startTime}
                                                onChange={(e) => handleSessionChange(dayIndex, sessIndex, 'startTime', e.target.value)}
                                            />
                                            <TextField
                                                margin="dense"
                                                label="End Time"
                                                type="time"
                                                InputLabelProps={{ shrink: true }}
                                                value={sess.endTime}
                                                onChange={(e) => handleSessionChange(dayIndex, sessIndex, 'endTime', e.target.value)}
                                            />
                                            <IconButton onClick={() => removeSession(dayIndex, sessIndex)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    ))}
                                    <Button variant="contained" onClick={() => addSession(dayIndex)}>Add Session</Button>
                                    <IconButton onClick={() => removeDay(dayIndex)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                            ))}
                            <Button variant="contained" type="Add" onClick={addDay}>Add Day</Button>

                            <Button variant="contained" style={{ float: 'right' }} onClick={handleUpdate}>Update Batch</Button>
                        </>
                    )}
                </DialogContent>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog open={deleteOpen} onClose={handleDeleteClose}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this batch?
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" type="Submit" onClick={handleDeleteClose}>Cancel</Button>
                    <Button variant="contained" type="error" onClick={handleDelete} >Delete</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};






const New = () => {
    const [tabValue, setTabValue] = useState(0);
    const [showModal, setShowModal] = useState(false);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleTabChange = (newValue) => {
        setTabValue(newValue);
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div>
            <Header />
            <br />
            <div className="d-flex justify-content-center mb-4">
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    aria-label="Batches-tabs"
                    variant="fullWidth"
                    className="d-md-flex justify-content-md-center"
                    sx={{
                        borderRadius: 10,
                        display: 'flex',
                        justifyContent: 'center',
                        "& button": {
                            display: 'flex',
                            justifyContent: 'center',
                        },
                        "& button:hover": {
                            backgroundColor: "#eee",
                        },
                        "& button:active": {
                            backgroundColor: "#ddd",
                        },
                        "& button.Mui-selected": {
                            backgroundColor: "#007bff",
                            color: "#fff",
                        },
                        "& .MuiTabs-indicator": {
                            display: 'none', // Remove the underline
                        },
                        ...(isMobile && {
                            flexDirection: 'column', // Stack tabs vertically
                            "& button": {
                                width: '100%', // Set tabs to full width on mobile
                            },
                        }),
                    }}
                >
                    <Tab label="Batches" sx={{ minWidth: isMobile ? '50%' : '600px' }} />
                    <Tab label="New Batches" sx={{ minWidth: isMobile ? '50%' : '600px' }} />
                </Tabs>
            </div>
            <div>
                {tabValue === 0 && <BatchesTable />}
                {tabValue === 1 && <NewBatches onFormSubmit={() => handleTabChange(0)} />}
            </div>
        </div>
    );
};

export default New;
